import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, DatePicker, Modal, Select, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import TextArea from "antd/lib/input/TextArea"
import { baseAxiosNoInfo, baseAxiosComplete } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 }
}

interface Prop {
    serviceRecord?: ServiceRecord
    onChange?: () => void
}

interface ServiceRecord {
    work_id: string, // 上单标识
    nursing_care_type: number // 护理模式
    nursing_care_type_desc: string // 护理模式描述
    belong_nursing_name: string  // 护理师
    service_status: number // 服务状态
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [employeeList, setEmployeeList] = useState<any[]>([])

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    useEffect(() => {
        baseAxiosNoInfo('/yuesao_center/global/archives_list', {

        }).then((res: any) => {
            if (res) {
                setEmployeeList(res)
            }
        })
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/yuesao_center/customer/detail/replace_nursing', {
            work_id: prop.serviceRecord?.work_id,
            advance_date: form.getFieldValue('advance_date') ? form.getFieldValue('advance_date').format('YYYY-MM-DD HH:mm:ss') : '',
            advance_reason: form.getFieldValue('advance_reason'),
            up_order_date: form.getFieldValue('up_order_date') ? form.getFieldValue('up_order_date').format('YYYY-MM-DD HH:mm:ss') : '',
            belong_nursing_id: form.getFieldValue('belong_nursing_id')
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 月嫂中心 -> 客户管理 -> 客户详情 -> 更换护理师 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>更换护理师</Button>

        <Modal title="更换护理师" width={450} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <p>当前护理模式：{prop.serviceRecord && prop.serviceRecord?.nursing_care_type_desc}</p>
            <p>当前护理师：{prop.serviceRecord && prop.serviceRecord?.belong_nursing_name}</p>
            <p>开始日期：{prop.serviceRecord && prop.serviceRecord?.service_start_date}</p>

            <Form form={form} {...formItemLayout} style={{ marginTop: 20 }} >
                <Form.Item required name="advance_date" label="原护理师下单日期" >
                    <DatePicker showTime />
                </Form.Item>

                <Form.Item required name="advance_reason" label="原护理师下单原因" >
                    <TextArea style={{ height: 100 }} />
                </Form.Item>

                <Form.Item required name="up_order_date" label="新上单日期" >
                    <DatePicker showTime />
                </Form.Item>

                <Form.Item required name="belong_nursing_id" label="新护理师">
                    <Select showSearch allowClear
                        filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                        {employeeList.map((el: any) => (<Option value={el.id} key={el.id} >{el.user_name}</Option>))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    </Fragment>
}